/**
 * Helper to solve index issues with owl carousel
 *
 *
 *
 * Warning! Can be used only with single-item carousel as it does use page plugin to take index from
 *
 * @type {{getCorrectIndex: module.exports.getCorrectIndex}}
 */
module.exports = {

    /**
     * Calculates correct index for carousel events with the help of page plugin
     *
     * @param event
     * @return {number}
     */
    getCorrectIndex: function (event) {
        var pageIndex = event.page.index,
            index;

        // We should have separate logic for different page sizes
        if (event.page.size > 1) {
            index = event.item.index;
            if (index === null) {
                index = 0;
            }
        } else {
            index = pageIndex === -1 ? 0 : pageIndex;
        }
        return index;
    },

    /**
     * We need to know correct last item index when we achieve last slide page,
     * e.g. it's 2 (page num) for carousel with 5 items on page and 7 items in total (0 0 0 0 0 1 2)
     *
     * @param event
     * @return {number}
     */
    getCorrectLastIndexFromCarouselEvent: function (event) {
        var count = event.item.count,
            pageSize = event.page.size;

        // We have less items than item count on page option - it's always 0
        if (count < pageSize) {
            return 0;
        }

        // From whole number of items count we subtract page size, because currentIndex for any item on first page is 0
        return count - pageSize;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/helper/index-helper.js
// module id = 15
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17